export default function formatComponentName(name: string) {
    const formattedName = name.toLowerCase().replace(/ /g, '_');
    const cookieName = `component_${formattedName}_is_dismissed`;
    return cookieName;
}
